var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherVolcano(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.2 12.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n        stroke: #02222b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st1 {\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M.8,12s3-4.9,3.2-6.5v-1.1h6.1v1c0,1.5,3.4,6.6,3.4,6.6H.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.7,
    y1: 1.2,
    x2: 7.7,
    y2: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.7,
    y1: 2.5,
    x2: 7.7,
    y2: 2.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.5,
    y1: 1.2,
    x2: 4.5,
    y2: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.5,
    y1: 2.5,
    x2: 4.5,
    y2: 2.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.1,
    y1: 1.9,
    x2: 6.1,
    y2: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.1,
    y1: 0.5,
    x2: 6.1,
    y2: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.3,
    y1: 1.9,
    x2: 9.3,
    y2: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.3,
    y1: 0.5,
    x2: 9.3,
    y2: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherVolcano);
export default __webpack_public_path__ + "static/media/icon_weather_volcano.9f8ba1fc4f2035538087169351d39dc3.svg";
export { ForwardRef as ReactComponent };